import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gy-5 g-xl-8" }
const _hoisted_2 = { class: "d-flex flex-wrap flex-stack pb-7 justify-content-between" }
const _hoisted_3 = { class: "d-flex flex-wrap align-items-center my-1" }
const _hoisted_4 = { class: "fw-bolder me-5 my-1" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_6 = { class: "svg-icon svg-icon-3 position-absolute ms-3" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "d-flex flex-wrap align-items-center my-1" }
const _hoisted_9 = { class: "row gy-5 gx-xl-8" }
const _hoisted_10 = { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_SitesTable = _resolveComponent("SitesTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('SITES.SEARCH')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "form-control form-control-white form-control-sm w-515px ps-9",
            id: "kt_filter_search",
            type: "text",
            placeholder: _ctx.placeholder,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event))
          }, null, 8, _hoisted_7), [
            [_vModelText, _ctx.filter]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
        }, _toDisplayString(_ctx.$t('SITES.ADD')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_SitesTable, {
          "widget-classes": "mb-6",
          actions: false,
          havePagination: true,
          filter: _ctx.filter
        }, null, 8, ["filter"])
      ])
    ])
  ]))
}